import React from 'react'
import { View, ImageBackground, Image, Platform, StatusBar, NativeModules } from 'react-native'
import { colors } from '../const'
import { CircleButton } from './Button'
import { HeaderLight } from './TextStyles'
import styles from '../../shared/styles'
import back_arrow from '../assets/icon/back_arrow.png'
import close_ic from '../assets/ic_120/close_ic_white.png'
import headerbg from '../assets/header_bg.png'
import { ProfileAvatar } from './Image'

const DeviceInfo = NativeModules.DeviceInfo
let isIPhoneX = false
if (Platform.OS === 'ios') { isIPhoneX = DeviceInfo.isIPhoneX_deprecated }

const Header = ({ title, right, goBack, left, hidden }) => {
  if (hidden) return null
  StatusBar.setBarStyle('light-content')
  if (Platform.OS === 'android') { StatusBar.setBackgroundColor(colors.midnightBack) }

  return (
    <ImageBackground source={headerbg} style={[styles.header, { height: Platform.select({ android: 56, ios: isIPhoneX ? 84 : 64, web: 70 }), alignItems: 'center', paddingTop: Platform.OS === 'ios' ? isIPhoneX ? 35 : 20 : 0 }]}>
      {
        goBack
          ? <CircleButton
            component={(<Image style={{ height: 17, width: 17 }} source={back_arrow} resizeMode='contain' />)}
            onPress={goBack}
            />
          : left || <View style={{ width: 50, height: 55 }} />
      }
      <HeaderLight title={title} numberOfLines={1} />
      {right || <View style={{ width: 50, height: 55 }} />}
    </ImageBackground>
  )
}

const ChatHeader = ({ title, right, goBack, left, lastMessageIcon }) => {
  return (
    <ImageBackground source={headerbg} style={[{ height: Platform.select({ android: 56, ios: 44, web: 70 }), flexDirection: 'row', alignItems: 'center' }]}>

      {
        goBack
          ? <CircleButton
            component={(<Image style={{ height: 17, width: 17 }} source={back_arrow} resizeMode='contain' />)}
            onPress={goBack}
            />
          : left || <View style={{ width: 50, height: 55 }} />
      }

      <View style={{ height: 30, width: 30, backgroundColor: colors.app_background, borderRadius: 30, marginHorizontal: 5 }}>
        <ProfileAvatar src={lastMessageIcon} />
      </View>

      <HeaderLight title={title} />
      {right || <View style={{ width: 50, height: 55 }} />}
    </ImageBackground>
  )
}

const HeaderBackground = () => (
  <Image
    style={{ position: 'absolute', overflow: 'hidden', height: '100%', width: '100%' }}
    source={headerbg}
  />
)

const HeaderLeft = (props) => (
  <CircleButton
    component={(<Image style={{ height: 16, width: 16 }} source={back_arrow} resizeMode='contain' />)}
    {...props}
  />
)

const HeaderRight = (props) => (
  <CircleButton
    component={(<Image style={{ height: 16, width: 16 }} source={close_ic} resizeMode='contain' />)}
    {...props}
  />
)

export default Header
export { HeaderBackground, HeaderLeft, HeaderRight, ChatHeader }
